import { useState } from "react";

import { ReminderElipses } from "../lead-inventory/icons";
import FileUploadComponent from "./TestSectionUpload";
import { useFetchExistingFiles } from "@/api/files/useFetchExistingFiles";
import ShowDocuments from "./ShowDocuments";
import AdditionalDetails from '../onboarding-documents/AdditionalDetailsNew.jsx';

export default function DocumentsTab({leadID, funnel}) {
    
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const hunterID = 195;
    const [fromOpp, setFromOpp] = useState(true);

    // State variables to track documents visibilty (show more button)
    const [showLoaDocs, setShowLoaDocs] = useState(false);
    const [showIdDocs, setShowIdDocs] = useState(false);
    const [showOthersDocs, setShowOthersDocs] = useState(false);

    const toggleLoaDocs = () => setShowLoaDocs(!showLoaDocs);
    const toggleIdDocs = () => setShowIdDocs(!showIdDocs);
    const toggleOthersDocs = () => setShowOthersDocs(!showOthersDocs);

    const openLoaModal = () => setIsLoaModalOpen(true);
    const closeLoaModal = () => setIsLoaModalOpen(false);
    const [isLoaModalOpen, setIsLoaModalOpen] = useState(false);

    const openIdModal = () => setIsIdModalOpen(true);
    const closeIdModal = () => setIsIdModalOpen(false);
    const [isIdModalOpen, setIsIdModalOpen] = useState(false);

    const openOthersModal = () => setIsOthersModalOpen(true);
    const closeOthersModal = () => setIsOthersModalOpen(false);
    const [isOthersModalOpen, setIsOthersModalOpen] = useState(false);

    //Create a refresh function to pass the upload component
    const refreshFiles = () => {
        setRefreshTrigger(prev => prev + 1);
    };

    const {idFileCount,loaFileCount, othersFileCount,idFile,loaFile,othersFile} = useFetchExistingFiles(leadID, refreshTrigger);
    
    
    return(
        <>
        <div className="mx-4 p-4 rounded-lg bg-white shadow-md mb-3">
            {funnel === 'Re-KYC' && (
                <h1 className="p-4 text-xl font-bold">Re-KYC Documents</h1>
            )}
            {funnel === 'Referral' && (
                <h1 className="p-4 text-xl font-bold">Referral Documents</h1>
            )}
            {funnel === 'Financing' && (
                <h1 className="p-4 text-xl font-bold">Financing Documents</h1>
            )}
            {funnel === 'Insurance' && (
                <h1 className="p-4 text-xl font-bold">Insurance Documents</h1>
            )}
            <div className="p-4 border-b flex flex-row gap-4 items-center justify-between">
                <div className="flex flex-row gap-4 pt-2 mt-2 items-center">
                    <a className="font-bold">Letter of Authorization</a>
                    <img src={ReminderElipses} alt="Reminder Elipses" className="w-2 h-2"/>
                    <p className="text-[#94A3B8]">{loaFileCount} Document(s) </p>
                </div>
                <div className="flex flex-row gap-4 items-center">
                    <button 
                    onClick={openLoaModal}
                    className="font-bold border w-auto p-2 rounded-full border-[#F7E21E] bg-[#F7E21E] text-[#1E293B] hover:bg-blue-500">Upload</button>
                    <button 
                    onClick={toggleLoaDocs}
                    className="rounded-full border p-1 border-[#1E293B] hover:bg-gray-200">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className={`size-6 transation-transform ${showLoaDocs ? 'rotate-90' : ''}`}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                        </svg>
                    </button>
                </div> 
            </div>
            {showLoaDocs && (
                <div>
                    <ShowDocuments  documents={loaFile} fileCount={loaFileCount}/>
                </div>
            )}
            <div className="p-4 border-b flex flex-row gap-4 items-center justify-between">
                <div className="flex flex-row gap-4 pt-2 mt-2 items-center">
                    <a className="font-bold">Identification Documents</a>
                    <img src={ReminderElipses} alt="Reminder Elipses" className="w-2 h-2"/>
                    <p className="text-[#94A3B8]">{idFileCount} Document(s) </p>
                </div>
                <div className="flex flex-row gap-4 items-center">
                    <button 
                    onClick={openIdModal}
                    className="font-bold border w-auto p-2 rounded-full border-[#F7E21E] bg-[#F7E21E] text-[#1E293B] hover:bg-blue-500">Upload</button>
                    <button 
                    onClick={toggleIdDocs}
                    className="rounded-full border p-1 border-[#1E293B] hover:bg-gray-200">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className={`size-6 transation-transform ${showIdDocs ? 'rotate-90' : ''}`}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                        </svg>
                    </button>
                </div>
            </div>
                {showIdDocs && (
                <div>
                    <ShowDocuments  documents={idFile} fileCount={idFileCount}/>
                </div>
            )} 
            <div className="p-4 border-b flex flex-row gap-4 items-center justify-between">
                <div className="flex flex-row gap-4 pt-2 mt-2 items-center">
                    <a className="font-bold">Others</a>
                    <img src={ReminderElipses} alt="Reminder Elipses" className="w-2 h-2"/>
                    <p className="text-[#94A3B8]">{othersFileCount} Document(s) </p>
                </div>
                <div className="flex flex-row gap-4 items-center">
                    <button 
                    onClick={openOthersModal}
                    className="font-bold border w-auto p-2 rounded-full border-[#F7E21E] bg-[#F7E21E] text-[#1E293B] hover:bg-blue-500">Upload</button>
                    <button 
                    onClick={toggleOthersDocs}
                    className="rounded-full border p-1 border-[#1E293B] hover:bg-gray-200">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className={`size-6 transation-transform ${showOthersDocs ? 'rotate-90' : ''}`}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                        </svg>
                    </button>
                </div>
            </div>
            {showOthersDocs && (
                <div>
                    <ShowDocuments  documents={othersFile} fileCount={othersFileCount}/>
                </div>
            )} 
            {/* Submit button for sending re-kyc email to compliance */}
        </div>
        {funnel === 'Re-KYC' && (
            <>
            <AdditionalDetails hunterID={hunterID} leadID={leadID} fromOpp={fromOpp}/>
            </>
        )}
        {isLoaModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                <div className="bg-white h-auto w-[60%] p-6 rounded-lg shadow-xl relative">
                    <button 
                        className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
                        onClick={closeLoaModal}
                    >
                        ✕
                    </button>
                    <FileUploadComponent 
                        docType="loa" 
                        title="Letter of Authorization" 
                        leadID = {leadID}
                        onUploadSuccess={refreshFiles}
                    />
                    {loaFileCount > 0 ? (
                        <ul className="mt-2 text-sm max-h-48 overflow-y-auto">
                        {loaFile.map((file, index) => (
                            <li key={index} className="mb-4 p-4 border-[#E2E8F0] bg-[#E2E8F0] rounded-lg flex flex-row gap-3 items-center relative">
                                <div className="flex flex-row gap-3 items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-10">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                                    </svg>
                                    <span className="flex flex-col gap-2 justify-center">
                                        <p className="font-bold text-base">{file.filename.substring(0, file.filename.lastIndexOf('.')) || file.filename}</p>
                                        <span className="flex-row gap-4 justify-center">
                                            <a className="text-base gap-4">{file.filename.substring(file.filename.lastIndexOf('.') + 1)}</a>
                                            <a className="text-xs px-4 text-[#94A3B8]">{(file.size / 1024).toFixed(2)} KB</a>
                                        </span>
                                    </span>
                                </div>
                            </li>
                        ))}
                    </ul>
                    ) : (
                        <p className="flex text-sm text-gray-500 justify-center">No files found for this product</p>
                    )}
                </div>
            </div>
        )}
        {isIdModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                <div className="bg-white h-auto w-[60%] p-6 rounded-lg shadow-xl relative">
                    <button 
                        className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
                        onClick={closeIdModal}
                    >
                        ✕  
                    </button>
                    <FileUploadComponent 
                        docType="id" 
                        title="Identification Documents"
                        leadID = {leadID}
                        onUploadSuccess={refreshFiles}
                    />
                    {idFileCount > 0 ? (
                        <ul className="mt-2 text-sm max-h-48 overflow-y-auto">
                        {idFile.map((file, index) => (
                            <li key={index} className="mb-4 p-4 border-[#E2E8F0] bg-[#E2E8F0] rounded-lg flex flex-row gap-3 items-center relative">
                                <div className="flex flex-row gap-3 items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-10">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                                    </svg>
                                    <span className="flex flex-col gap-2 justify-center">
                                        <p className="font-bold text-base">{file.filename.substring(0, file.filename.lastIndexOf('.')) || file.filename}</p>
                                        <span className="flex-row gap-4 justify-center">
                                            <a className="text-base gap-4">{file.filename.substring(file.filename.lastIndexOf('.') + 1)}</a>
                                            <a className="text-xs px-4 text-[#94A3B8]">{(file.size / 1024).toFixed(2)} KB</a>
                                        </span>
                                    </span>
                                </div>
                            </li>
                        ))}
                    </ul>
                    ) : (
                        <p className="flex text-sm text-gray-500 justify-center">No files found</p>
                    )}
                </div>
            </div>
        )}
        {isOthersModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                <div className="bg-white h-auto w-[60%] p-6 rounded-lg shadow-xl relative">
                    <button 
                        className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
                        onClick={closeOthersModal}
                    >
                        ✕
                    </button>
                    <FileUploadComponent 
                        docType="misc" 
                        title="Others" 
                        leadID = {leadID}
                        onUploadSuccess={refreshFiles}
                    />
                    {othersFileCount > 0 ? (
                        <ul className="mt-2 text-sm max-h-48 overflow-y-auto">
                        {othersFile.map((file, index) => (
                            <li key={index} className="mb-4 p-4 border-[#E2E8F0] bg-[#E2E8F0] rounded-lg flex flex-row gap-3 items-center relative">
                                <div className="flex flex-row gap-3 items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-10">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                                    </svg>
                                    <span className="flex flex-col gap-2 justify-center">
                                        <p className="font-bold text-base">{file.filename.substring(0, file.filename.lastIndexOf('.')) || file.filename}</p>
                                        <span className="flex-row gap-4 justify-center">
                                            <a className="text-base gap-4">{file.filename.substring(file.filename.lastIndexOf('.') + 1)}</a>
                                            <a className="text-xs px-4 text-[#94A3B8]">{(file.size / 1024).toFixed(2)} KB</a>
                                        </span>
                                    </span>
                                </div>
                            </li>
                        ))}
                    </ul>
                    ) : (
                        <p className="flex text-sm text-gray-500 justify-center">No files found</p>
                    )}
                </div>
            </div>
        )}
        </>
    );
};
